import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableFooterProps = ComponentProps<'tfoot'>;

const TableFooter = ({ className, ...props }: TableFooterProps) => {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn(
        'border-t-2 border-gray-300 bg-gray-100 font-semibold [&>tr]:last:border-b-0',
        className,
      )}
      {...props}
    />
  );
};

export default TableFooter;
